import { getAppParams } from "./getAppParams"

const params = getAppParams()

export const APP_TYPE = params.app_type
export const APP_VERSION = params.app_version
export const IS_APP = APP_TYPE !== undefined
